module.exports = __webpack_public_path__ + "static/media/step-indicator-2.f4cbb7b4.svg";